module.exports = __webpack_public_path__ + "static/media/background-6.a3803c98.jpg";